<template>
    <update-email-modal
        v-if="update_email_modal"
        :user="user"
        :show="update_email_modal"
        @closeModal="update_email_modal = false"
        @close="update_email_modal = false"
        @closeModalAndFetch="closeAndFetchApproveModal()"
    />
     <update-phone-modal
        v-if="update_phone_modal"
        :user="user"
        :show="update_phone_modal"
        @closeModal="update_phone_modal = false"
        @close="update_phone_modal = false"
        @closeModalAndFetch="closeAndFetchApproveModal()"
    />
    <approve-user-modal
        v-if="approve_user_modal"
        @closeModal="closeApproveModal()"
        @closeModalAndFetch="closeAndFetchApproveModal()"
    />
    <impersonate-user-modal
        v-if="impersonate_user_modal"
        @closeModal="impersonate_user_modal = false"
        @closeModalAndFetch="closeAndFetchApproveModal()"
    />
    <block-user-modal
        v-if="block_user_modal"
        @closeModal="closeBlockModal()"
        @closeModalAndFetch="closeAndFetchBlockModal()"
    />
    <release-cashout-modal
        v-if="release_cashout_modal"
        @closeModal="release_cashout_modal = false"
        @closeModalAndFetch="closeAndFetchReleaseCashoutModal()"
    />
    <block-cashout-modal
        v-if="block_cashout_modal"
        @closeModal="block_cashout_modal = false"
        @closeModalAndFetch="closeAndFetchBlockCashoutModal()"
    />
    <!-- Discord Modal -->
    <modal :open="discord_modal" @close="discord_modal = false">
        <div class="mb-4 text-center">
            <h3 class="text-lg font-medium text-gray-900 dark:text-white">Enviar para Discord</h3>
            <div class="mt-2">
                <p class="text-sm text-gray-500 dark:text-gray-300">
                    Deseja enviar as informações deste usuário para o canal Discord?
                </p>
            </div>
        </div>

        <div class="mt-5 flex justify-end space-x-2">
            <button
                @click="discord_modal = false"
                class="inline-flex items-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
            >
                Cancelar
            </button>
            <button
                @click="sendToDiscord"
                :disabled="discord_sending"
                class="inline-flex items-center rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 disabled:opacity-50"
            >
                <svg v-if="discord_sending" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                {{ discord_sending ? 'Enviando...' : 'Enviar' }}
            </button>
        </div>
    </modal>

    <div>
        <span
            v-if="balance_updating"
            :class="{ 'cursor-not-allowed': balance_updating }"
            class="inline-flex items-center px-4 py-2 font-semibold leading-6 text-sm shadow rounded-md text-white transition ease-in-out duration-150"
        >
            <svg
                class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
            >
                <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                ></circle>
                <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
            </svg>
            Atualizando saldo...
        </span>

        <menu-headless as="div" class="relative inline-block text-left">
            <div>
                <menu-button
                    class="ml-2 px-2 py-2 inline-flex justify-center w-full rounded-md border: bg-indigo-500 hover:bg-indigo-400 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-700 focus:ring-indigo-500"
                >
                    Opções
                    <font-awesome-icon
                        icon="fa-solid fa-chevron-down"
                        class="-mr-1 ml-2 h-5 w-5"
                        aria-hidden="true"
                    />
                </menu-button>
            </div>

            <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
            >
                <menu-items
                    class="origin-top-right absolute right-0 z-10 mt-2 w-56 rounded-md shadow-lg bg-gray-700 ring-1 ring-black ring-opacity-5 divide-y divide-gray-700 focus:outline-none"
                >
                    <div
                        class="py-1 divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600"
                    >
                        <menu-item v-if="hasPermission('update.user.email')" v-slot="{ active }" @click="update_email_modal = true" class="hover:cursor-pointer">
                            <p
                                :class="[
                                    active
                                        ? 'bg-gray-800/25 text-slate-200'
                                        : 'text-slate-50',
                                    'block px-4 py-2 text-sm',
                                ]"
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-envelope"
                                    class="mr-2"
                                    aria-hidden="true"
                                />
                                Alterar E-mail
                            </p>
                        </menu-item>

                         <menu-item v-if="hasPermission('update.user.email')" v-slot="{ active }" @click="update_phone_modal = true" class="hover:cursor-pointer">
                            <p
                                :class="[
                                    active
                                        ? 'bg-gray-800/25 text-slate-200'
                                        : 'text-slate-50',
                                    'block px-4 py-2 text-sm',
                                ]"
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-phone"
                                    class="mr-2"
                                    aria-hidden="true"
                                />
                                Alterar Telefone
                            </p>
                        </menu-item>

                        <menu-item v-slot="{ active }" @click="updateBalance" class="hover:cursor-pointer">
                            <p
                                :class="[
                                    active
                                        ? 'bg-gray-800/25 text-slate-200'
                                        : 'text-slate-50',
                                    'block px-4 py-2 text-sm',
                                ]"
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-money-bills"
                                    class="mr-2"
                                    aria-hidden="true"
                                />
                                Atualizar Saldo
                            </p>
                        </menu-item>
                        <menu-item v-slot="{ active }" @click="invalidateOfferCache" class="hover:cursor-pointer">
                            <p
                                :class="[
                                    active
                                        ? 'bg-gray-800/25 text-slate-200'
                                        : 'text-slate-50',
                                    'block px-4 py-2 text-sm',
                                ]"
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-sync"
                                    class="mr-2"
                                    aria-hidden="true"
                                />
                                Invalidar Cache de Ofertas
                            </p>
                        </menu-item>
                        <menu-item v-slot="{ active }" @click="discord_modal = true" class="hover:cursor-pointer">
                            <p
                                :class="[
                                    active
                                        ? 'bg-gray-800/25 text-slate-200'
                                        : 'text-slate-50',
                                    'block px-4 py-2 text-sm',
                                ]"
                            >
                                <font-awesome-icon
                                    icon="fa-brands fa-discord"
                                    class="mr-2"
                                    aria-hidden="true"
                                />
                                Discord
                            </p>
                        </menu-item>
                        <div>
                            <div>
                                <menu-item
                                    v-if="user?.setting?.is_blocked"
                                    v-slot="{ active }"
                                    @click="openBlockModal()"
                                    class="hover:cursor-pointer"
                                >
                                    <p
                                        :class="[
                                            active
                                                ? 'bg-green-700/90 text-slate-200'
                                                : 'bg-green-700 text-slate-50',
                                            'block px-4 py-2 text-sm items-center',
                                        ]"
                                    >
                                        <font-awesome-icon
                                            icon="fa-solid fa-check"
                                            class="mr-2"
                                            aria-hidden="true"
                                        />
                                        Desbloquear Usuário
                                    </p>
                                </menu-item>
                                <menu-item
                                    v-else
                                    v-slot="{ active }"
                                    @click="openBlockModal()"
                                    class="hover:cursor-pointer"
                                >
                                    <p
                                        :class="[
                                            active
                                                ? 'bg-red-700/90 text-slate-200'
                                                : 'bg-red-700 text-slate-50',
                                            'block px-4 py-2 text-sm items-center',
                                        ]"
                                    >
                                        <font-awesome-icon
                                            icon="fa-solid fa-ban"
                                            class="mr-2"
                                            aria-hidden="true"
                                        />
                                        Bloquear Usuário
                                    </p>
                                </menu-item>
                            </div>
                            <menu-item
                                v-slot="{ active }"
                                @click.prevent="deleteUser()"
                                class="hover:cursor-pointer"
                            >
                                <p
                                    :class="[
                                        active
                                            ? 'bg-red-700/90 text-slate-200'
                                            : 'bg-red-700 text-slate-50',
                                        'block px-4 py-2 text-sm items-center',
                                    ]"
                                >
                                    <font-awesome-icon
                                        icon="fa-solid fa-times"
                                        class="mr-2"
                                        aria-hidden="true"
                                    />
                                    Deletar Usuário
                                </p>
                            </menu-item>
                            <menu-item
                                v-if="hasPermission('impersonate.users')"
                                v-slot="{ active }"
                                @click="openImpersonateModal()"
                                class="hover:cursor-pointer"
                            >
                                <p class="block text-white px-4 py-2 text-sm items-center">
                                    <font-awesome-icon
                                        icon="fa-solid fa-sign-in"
                                        class="mr-2"
                                        aria-hidden="true"
                                    />
                                    Impersonate
                                </p>
                            </menu-item>
                            <menu-item
                                v-if="!user.is_approved"
                                v-slot="{ active }"
                                @click="openApproveModal()"
                                class="hover:cursor-pointer"
                            >
                                <p
                                    :class="[
                                        active
                                            ? 'bg-green-700/90 text-slate-200'
                                            : 'bg-green-700 text-slate-50',
                                        'block px-4 py-2 text-sm items-center',
                                    ]"
                                >
                                    <font-awesome-icon
                                        icon="fa-solid fa-check"
                                        class="mr-2"
                                        aria-hidden="true"
                                    />
                                    Aprovar Usuário
                                </p>
                            </menu-item>
                            <menu-item
                                v-if="hasPermission('manage.blocked_balances') && !user?.has_cashout_released"
                                v-slot="{ active }"
                                @click="release_cashout_modal = true"
                                class="hover:cursor-pointer"
                            >
                                <p
                                    :class="[
                                        active
                                            ? 'bg-green-700/90 text-slate-200'
                                            : 'bg-green-700 text-slate-50',
                                        'block px-4 py-2 text-sm items-center',
                                    ]"
                                >
                                    <font-awesome-icon
                                        icon="fa-solid fa-money-bill-transfer"
                                        class="mr-2"
                                        aria-hidden="true"
                                    />
                                    Liberar Saque
                                </p>
                            </menu-item>
                            <menu-item
                                v-if="hasPermission('manage.blocked_balances') && user?.has_cashout_released"
                                v-slot="{ active }"
                                @click="block_cashout_modal = true"
                                class="hover:cursor-pointer"
                            >
                                <p
                                    :class="[
                                        active
                                            ? 'bg-red-700/90 text-slate-200'
                                            : 'bg-red-700 text-slate-50',
                                        'block px-4 py-2 text-sm items-center',
                                    ]"
                                >
                                    <font-awesome-icon
                                        icon="fa-solid fa-money-bill-transfer"
                                        class="mr-2"
                                        aria-hidden="true"
                                    />
                                    Bloquear Saque
                                </p>
                            </menu-item>
                        </div>
                    </div>
                </menu-items>
            </transition>
        </menu-headless>
    </div>
</template>

<script>
import {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import { mapWritableState } from "pinia";
import { mapActions } from "pinia";
import { Store } from "../../stores/store";
import ApproveUserModal from "./modals/ApproveUserModal.vue";
import BlockUserModal from "./modals/BlockUserModal.vue";
import ImpersonateUserModal from "./modals/ImpersonateUserModal.vue";
import UpdateEmailModal from "./modals/UpdateEmailModal.vue";
import ReleaseCashoutModal from "./modals/ReleaseCashoutModal.vue";
import BlockCashoutModal from "./modals/BlockCashoutModal.vue";
import PermissionMixin from "../../mixins/PermissionMixin.vue";
import Modal from "../../components/layouts/Modal.vue";
import UpdatePhoneModal from "./modals/UpdatePhoneModal.vue"

export default {
    components: {
        UpdateEmailModal,
        ReleaseCashoutModal,
        BlockCashoutModal,
        MenuHeadless: Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        ApproveUserModal,
        BlockUserModal,
        ImpersonateUserModal,
        Modal,
        UpdatePhoneModal,
    },
    props: {
        wallet: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            update_email_modal: false,
            approve_user_modal: false,
            impersonate_user_modal: false,
            block_user_modal: false,
            release_cashout_modal: false,
            block_cashout_modal: false,
            discord_modal: false,
            balance_updating: false,
            loading: false,
            update_phone_modal: false,
        };
    },
    mixins: [PermissionMixin],
    computed: {
        ...mapWritableState(Store, ["user", "permissions"]),
    },
    methods: {
        ...mapActions(Store, ["fetchUser"]),
        openImpersonateModal() {
            this.impersonate_user_modal = true;
        },
        openApproveModal() {
            this.approve_user_modal = true;
        },
        closeApproveModal() {
            this.approve_user_modal = false;
        },
        closeAndFetchApproveModal() {
            this.approve_user_modal = false;
            this.user = null;
            this.fetchUser();
        },
        hasPermission(name) {
            return this.permissions.find(permission => permission.name === name)
        },
        userHasPermission(name) {
            return this.user?.permissions?.some(permission => permission.name === name) ?? false;
        },
        openBlockModal() {
            this.block_user_modal = true;
        },
        closeBlockModal() {
            this.block_user_modal = false;
        },
        closeAndFetchBlockModal() {
            this.block_user_modal = false;
            this.user = null;
            this.fetchUser();
        },
        closeAndFetchReleaseCashoutModal() {
            this.release_cashout_modal = false;
            this.user = null;
            this.fetchUser();
        },
        closeAndFetchBlockCashoutModal() {
            this.block_cashout_modal = false;
            this.user = null;
            this.fetchUser();
        },
        updateBalance() {
            if (!this.wallet?.id) {
                return;
            }
            this.balance_updating = true;
            axios
                .post("/api/user/" + this.$route.params.user_id + "/wallet/" + this.wallet.id + "/balance")
                .then(({ data }) => {
                    this.balance_updating = false;
                })
                .catch(({ response }) => {
                    this.balance_updating = false;
                });
        },
        invalidateOfferCache() {
            axios
                .post("/api/user/" + this.$route.params.user_id + "/invalidate-offer-cache")
                .then(({ data }) => {
                    this.$notify({
                        group: "success",
                        title: "Sucesso",
                        text: data?.message || "Cache de ofertas invalidado com sucesso!"
                    }, 4000);
                })
                .catch(({ response }) => {
                    this.$notify({
                        group: "error",
                        title: "Erro",
                        text: response?.data?.message || "Não foi possível invalidar o cache de ofertas."
                    }, 4000);
                });
        },
        deleteUser() {
            if (confirm("Tem certeza que deseja deletar este usuário?")) {
                axios.post(
                    '/api/user/' + this.user.id + '/delete'
                ).then(({data}) => {
                    this.$notify({
                        group: "success",
                        title: "Success",
                        text: data?.message || "Usuário deletado com sucesso!"
                    }, 4000);

                    this.$router.push({ path: '/users' })
                }).catch(({response}) => {
                    this.$notify({
                        group: "error",
                        title: "Error",
                        text: response?.data?.message || response?.data?.errors[0] || "Não foi possível concluir essa solicitação."
                    }, 4000);
                });
            }
        },
        sendToDiscord() {
            this.discord_modal = false;
            this.loading = true;

            axios
                .post("/api/user/" + this.$route.params.user_id + "/send-to-discord")
                .then(({ data }) => {
                    this.$toast.success(data.message);
                })
                .catch((error) => {
                    const message = error.response?.data?.message || 'Erro ao enviar para Discord';
                    this.$toast.error(message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatCurrency(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value / 100);
        },
    },
};
</script>

<style></style>
